export default function PolicyContact() {
  return <section className="mt-6 space-y-2 rounded border border-amber-300 bg-amber-50 p-5 text-sm">
    <h2 className="font-semibold">Privacy contact — pending CHARMS confirmation</h2>
    <p>Support/privacy email: [ADD OFFICIAL EMAIL]</p><p>Support phone: [ADD OFFICIAL PHONE]</p>
    <p>Registered address: [ADD REGISTERED POSTAL ADDRESS]</p>
    <p>Privacy/grievance contact: [ADD NAME, DESIGNATION AND CONTACT DETAILS]</p>
    <p>Account-deletion owner and response timeframe: [ADD TEAM AND TIMEFRAME]</p>
  </section>;
}
